// extracted by mini-css-extract-plugin
var _1 = "LabelForm-moduleformBody__jeM74";
export { _1 as "formBody" }
